import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from "react-router-dom"

import './styles/index.css'

import Index from "./routes/index"
import Home from "./routes/home"
import OnlineEligibility from "./routes/onlineEligibility"
import Login from "./routes/login"
import Register from "./routes/register"
import Residency from "./routes/residency"
import Exemptions from "./routes/exemptions"
import AddressChangeForm from "./routes/addressChangeForm"
import NoMatch from "./routes/noMatch"
import Return from "./routes/return"

const root = ReactDOM.createRoot(
    document.getElementById('root')
)

root.render(
    <BrowserRouter>
        <Routes>
            <Route path="/" element={<Index/>}>
                <Route path="home" element={<Home/>}/>
                <Route path="onlineEligibility" element={<OnlineEligibility/>}/>
                <Route path="register" element={<Register/>}/>
                <Route path="login" element={<Login/>}/>
                <Route path="residency" element={<Residency/>}/>
                <Route path="exemptions" element={<Exemptions/>}/>
                <Route path="addressChangeForm" element={<AddressChangeForm/>}/>
                <Route path="return" element={<Return/>}/>
                <Route path="*" element={<NoMatch/>}/>
            </Route>
        </Routes>
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()